// Module
var code = "<toolbar-color-menu colors=\"parent.elementColors\" menu-type=\"highlighter\" on-select=\"parent.updateHighlighterColor(color)\"> </toolbar-color-menu> ";
// Exports
module.exports = code;